export class FeedRepostNotification {
    publishDate: Date;
    content: string;
}



// WEBPACK FOOTER //
// ./src/app/main/feeds/shared/models/feed-repost-notification.model.ts